import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/logo3.png"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Godrej Horizon Wadala"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 className="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Godrej Properties is a leading name in India’s real estate industry,
        renowned for innovation, excellence, and customer trust. With a legacy
        spanning decades, Godrej Properties has transformed Mumbai’s skyline
        with premium residential and commercial developments. Godrej Horizon is
        an extension of this commitment to quality, offering ultra-modern homes
        with breathtaking views, top-tier amenities, and a prime location in
        Wadala. Designed to set a new benchmark for luxury living, this project
        ensures a perfect blend of sophistication, connectivity, and serenity.
        <br />
        <strong className="d-block">
          Invest in a home that reflects your success - Only with Godrej
          Properties.
        </strong>
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51900034851.PNG" alt="rera qr" />
          <strong>P51900034851</strong>
        </div>
        <div className="rera-item">
          <img src="images/rera-P51900049757.PNG" alt="rera qr" />
          <strong>P51900049757</strong>
        </div>
        <div className="rera-item">
          <img src="images/rera-P51900078358.PNG" alt="rera qr" />
          <strong>P51900078358</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
